export const formFilter = [
    {
        input: {
            id: 'periodoInicial',
            label: 'Data Inicial (Data Registro)',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'periodoFinal',
            label: 'Data Final',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        multiSelect: {
            id: 'ufDetran',
            label: 'Detran',
            optionsType: 'ufContract'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    }
]
